var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cross_2_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    fill: "#556065",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.545,15.292l-76,76c-0.977,0.977-2.256,1.465-3.536,1.465s-2.559-0.488-3.536-1.465c-1.953-1.952-1.953-5.118,0-7.07 l34.465-34.465L6.474,15.292c-1.953-1.953-1.953-5.119,0-7.071c1.954-1.952,5.119-1.951,7.071,0L48.01,42.686L82.475,8.221 c1.951-1.952,5.119-1.952,7.07,0C91.498,10.173,91.498,13.339,89.545,15.292z M60.982,55.659l-7.07,7.07l28.563,28.563 c0.976,0.977,2.256,1.465,3.535,1.465s2.56-0.488,3.535-1.465c0.977-0.976,1.465-2.256,1.465-3.535s-0.488-2.56-1.465-3.535 L60.982,55.659z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossGray);
export default __webpack_public_path__ + "static/media/crossGray.c30c7019fc8b8b7c0ec45b55dccdf09e.svg";
export { ForwardRef as ReactComponent };